import { z } from 'zod';
import { ImageLibraryAsset } from './image-asset';
import { VideoLibraryAsset } from './video-asset';

export const ZAsset = z.object({
    width: z.number(),
    height: z.number(),
    url: z.string().min(1)
});

export type OneOfLibraryAssets = ImageLibraryAsset | VideoLibraryAsset;
